import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const featuredExperiences = [
  {
    emoji: '🗣️',
    title: 'Tura sa Lokalnim Vodičem',
    price: 'od 45 EUR',
    bonusPoints: '+100 bonus bodova',
    multiplier: '2x bodovi',
  },
  {
    emoji: '🍽️',
    title: 'Food Tour — Lokalna Kuhinja',
    price: 'od 65 EUR',
    bonusPoints: '+150 bonus bodova',
    multiplier: null,
  },
  {
    emoji: '🏛️',
    title: 'VIP Muzejska Tura',
    price: 'od 80 EUR',
    bonusPoints: '+200 bonus bodova',
    multiplier: '2x bodovi',
  },
];

export const ExperienceTeaser: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-brand-900 via-brand-800 to-go2-blue">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wide mb-4">
            Obogati Putovanje
          </h2>
          <div className="w-24 h-1 bg-go2-yellow mx-auto mb-6"></div>
          <p className="text-xl text-brand-100 max-w-2xl mx-auto">
            Dodaj iskustva na svako putovanje — vodiči, food ture, avanture — i zaradi duplo više bodova
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {featuredExperiences.map((experience, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm text-white rounded-xl p-6 hover:bg-white/20 transition-all"
            >
              <div className="text-5xl mb-4 text-center">{experience.emoji}</div>
              <h3 className="text-xl font-bold mb-4 text-center">{experience.title}</h3>
              <div className="space-y-2 text-center">
                <div className="text-brand-100 font-semibold">{experience.price}</div>
                <div className="inline-block bg-go2-yellow text-brand-900 text-sm font-bold px-3 py-1 rounded-full">
                  {experience.bonusPoints}
                </div>
                {experience.multiplier && (
                  <div className="inline-block bg-white/20 text-white text-sm font-bold px-3 py-1 rounded-full ml-2">
                    {experience.multiplier}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/go2-legende/dashboard?tab=iskustva"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-brand-900 rounded-full font-bold text-lg hover:bg-brand-50 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 uppercase tracking-wide"
          >
            Istraži sva iskustva
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};
